import Vue from 'vue';

Vue.mixin({
    data: () => ({
        publicPath: '/app/themes/guliano/dist',
    }),
});
